import React, { useState, useEffect } from "react";
import axios from "axios";

axios.defaults.withCredentials = true;
const API_URL_FPS = process.env.REACT_APP_URL_HEADER;
const API_URL = process.env.REACT_APP_URL;

const monthNames = ["January", "February", "March", "April", "May", "June",
  "July", "August", "September", "October", "November", "December"];

export default function CommissionStatusReport() {
  const [state, setState] = useState({
    currentMonth: null,
    currentYear: null,
    prevMonth: null,
    prevYear: null,
    selectedMonth: null,
    selectedYear: null,
    records: [],
    loading: false,
    showTable: false,
    submittedMonth: null,
    submittedYear: null

  });

  useEffect(() => {
    const init = async () => {
      try {
        const [mRes, yRes] = await Promise.all([
          axios.get(`${API_URL_FPS}/Common/currentMonth`),
          axios.get(`${API_URL_FPS}/Common/currentYear`)
        ]);

        const curM = mRes.data;
        const curY = yRes.data;
        const prevM = curM === 1 ? 12 : curM - 1;
        const prevY = curM === 1 ? curY - 1 : curY;

        setState(s => ({
          ...s,
          currentMonth: curM,
          currentYear: curY,
          prevMonth: prevM,
          prevYear: curY - 1,
          nextYear: curY + 1,
          selectedMonth: curM,
          selectedYear: curY
        }));

        handleShowRecords(curM, curY);
      } catch (err) {
        console.error("Init failed:", err);
        alert("Failed to load current month/year");
      }
    };
    init();
  }, []);

  const handleShowRecords = async (month = state.selectedMonth, year = state.selectedYear) => {
    if (!month || !year) return;

    setState(s => ({ ...s, loading: true, showTable: false }));

    try {
      const res = await axios.get(`${API_URL}/api/fps/commission-status`, {
        params: { district: "", month, year }
      });

      setState(s => ({
        ...s,
        records: res.data || [],
        loading: false,
        showTable: true,
        submittedMonth: month,
        submittedYear: year
      }));

    } catch (err) {
      console.error("API Error:", err.response || err);
      alert("Failed to load commission status. Please try again.");
      setState(s => ({ ...s, loading: false, showTable: false }));
    }
  };

  const handleSubmit = () => {
    handleShowRecords();
  };

  return (
    <>

      <table width="50%" align="center"
        style={{ marginTop: "30px" }}>
        <tbody>
          <tr class="tableheader">
            <th colSpan="6" >
              FPS Commission Status Summary Report
            </th>
          </tr>
          <tr>
            <td><strong>Month:</strong></td>
            <td>
              <select
                value={state.selectedMonth || ""}
                onChange={e =>
                  setState(s => ({
                    ...s,
                    selectedMonth: Number(e.target.value)
                  }))
                }
              >
                <option value="">-- Select Month --</option>

                {monthNames.map((name, index) => (
                  <option key={index + 1} value={index + 1}>
                    {name}
                  </option>
                ))}
              </select>
            </td>


            <td><strong>Year:</strong></td>
            <td>
              <select
                value={state.selectedYear || ""}
                onChange={e =>
                  setState(s => ({ ...s, selectedYear: +e.target.value }))
                }
              >
                <option value="">-- Select Year --</option>

                <option value={state.prevYear}>{state.prevYear}</option>
                <option value={state.currentYear}>{state.currentYear}</option>
                <option value={state.nextYear}>{state.nextYear}</option>
              </select>

            </td>

            <td>
              <button
                onClick={handleSubmit}
                disabled={state.loading}
                class="button button2"
              >
                {state.loading ? "Loading..." : "Submit"}
              </button>
            </td>
            {/* <td>
              <button onClick={() => window.history.back()}
                style={{ padding: "10px 25px", backgroundColor: "#6c757d", color: "white", border: "none", borderRadius: "4px" }}>
                Back
              </button>
            </td> */}
          </tr>
        </tbody>
      </table>

      {/* Main Report Table */}
      {state.showTable && (
        <table width="75%" align="center"
          style={{ marginTop: "20px" }}>
          <thead>
            <tr class="tableheader">
              <th colSpan="14" >
                FPS Commission Status Summary Report
                <span style={{ fontSize: "20px" }}>
                  ({monthNames[state.submittedMonth - 1]} {state.submittedYear})
                </span>
              </th>
            </tr>

            <tr class="tableheader">
              <th rowSpan="2" style={th}>S.No</th>
              <th rowSpan="2" style={th}>District</th>
              <th rowSpan="2" style={th}>Bank Freeze</th>
              <th rowSpan="2" style={th}>Sale Qty Verify</th>
              <th rowSpan="2" style={th}>Commission</th>
              <th rowSpan="2" style={th}>TDS</th>
              <th rowSpan="2" style={th}>PTax</th>
              <th colSpan="3" style={th}>NFSA</th>
              <th colSpan="3" style={th}>State</th>
              <th rowSpan="2" style={th}>Statement</th>
            </tr>
            <tr class="tableheader">
              <th style={th}>Admin</th>
              <th style={th}>Accounts</th>
              <th style={th}>GM</th>
              <th style={th}>Admin</th>
              <th style={th}>Accounts</th>
              <th style={th}>GM</th>
            </tr>
          </thead>
          <tbody>
            {state.loading ? (
              <tr><td colSpan="14" >Loading...</td></tr>
            ) : state.records.length === 0 ? (
              <tr><td colSpan="14" >
                No data found for selected month/year
              </td></tr>
            ) : (
              state.records.map((row, i) => (
                <tr key={i} >
                  <td style={td}>{i + 1}</td>
                  <td style={td}><strong>{row.districtName}</strong></td>
                  <td style={row.bankFreezeDate ? success : danger}>
                    {row.bankFreezeDate ? "Freezed" : "Not Freezed"}
                  </td>
                  <td style={row.saleQtyVerifyDate ? success : danger}>
                    {row.saleQtyVerifyDate ? "Verified" : "Not Verified"}
                  </td>
                  <td style={row.commDate ? success : danger}>
                    {row.commDate ? "Generated" : "Not Generated"}
                  </td>
                  <td style={row.tdsDate ? success : danger}>
                    {row.tdsDate ? "Generated" : "Not Generated"}
                  </td>
                  <td style={row.ptaxDate ? success : danger}>
                    {row.ptaxDate ? "Generated" : "Not Generated"}
                  </td>
                  <td style={row.adminVerifyDateNfsa ? success : danger}>
                    {row.adminVerifyDateNfsa ? "Verified" : "Not Verified"}
                  </td>
                  <td style={row.accountsVerifyDateNfsa ? success : danger}>
                    {row.accountsVerifyDateNfsa ? "Verified" : "Not Verified"}
                  </td>
                  <td style={row.gmVerifyDateNfsa ? success : danger}>
                    {row.gmVerifyDateNfsa ? "Verified" : "Not Verified"}
                  </td>
                  <td style={row.adminVerifyDateState ? success : danger}>
                    {row.adminVerifyDateState ? "Verified" : "Not Verified"}
                  </td>
                  <td style={row.accountsVerifyDateState ? success : danger}>
                    {row.accountsVerifyDateState ? "Verified" : "Not Verified"}
                  </td>
                  <td style={row.gmVerifyDateState ? success : danger}>
                    {row.gmVerifyDateState ? "Verified" : "Not Verified"}
                  </td>
                  <td style={row.downloadDateState ? success : danger}>
                    {row.downloadDateState ? "Generated" : "Not Generated"}
                  </td>
                </tr>
              ))
            )}
          </tbody>

        </table>

      )}
      <br />
      <div style={{ height: "50px" }}></div>

    </>
  );
}

const th = {};
const td = {};
const success = { ...td, backgroundColor: "#d4edda", color: "#155724", fontWeight: "bold" };
const danger = { ...td, backgroundColor: "#f8d7da", color: "#721c24", fontWeight: "bold" };